// extracted by mini-css-extract-plugin
export default {"root":"LcHKo","rotator":"+NMl-","dash":"VWEqz"};